import { connect } from "react-redux";
import { routesPathConstants, STORE_BILLING_STATUS } from "../../constants";
import { Link } from "react-router-dom";
import { createCompanyDynamicUrl } from "../../shared/utility";

const StoreInActive = (props) => {
  const { currentStore } = props;
  const storeBillingStatus = currentStore.billing?.storeBillingStatus;

  return storeBillingStatus === STORE_BILLING_STATUS.SERVICE_SUSPENDED ? (
    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center my-5 py-5">
      <h4 className="text-center p-0 m-0">
        Store access disabled due to pending payment. Please
      </h4>
      &nbsp;
      <Link
        className="text-primary"
        to={createCompanyDynamicUrl(routesPathConstants.PAYOUTS)}
      >
        <h4 className="text-center p-0 m-0">complete payment</h4>
      </Link>
    </div>
  ) : (
    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center my-5 py-5">
      <h4 className="text-center p-0 m-0">
        Store is deactivated, please contact your administrator:
      </h4>
      &nbsp;
      <a className="text-primary" href="mailto:support@collectpos.com">
        <h4 className="text-center p-0 m-0">support@collectpos.com</h4>
      </a>
    </div>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StoreInActive);
